import React, { useEffect, useState } from 'react'
import { formatCurrency } from 'medere-ui-framework'
import { Big, BigConstructor } from 'big.js'
import { EarningWithholdingConceptDTO, TaxTypeDTO } from '../../interface/interface'
import TaxTypeItem from './TaxTypeItem'
import { axiosInstance } from '../../App'
import { usePaymentOrder } from '../../components/context/PaymentOrderContext'

type PaidTax = {
  taxtype: number;
  amount: Big;
  percentage: Big;
};
interface TaxTypesComponentProps {
  totalToPay: Big
  setTotalToPay:(ttp:Big) => void,
  operationType: number;
  earningWithHoldingConcept: EarningWithholdingConceptDTO,
  setEarningWithHoldingConcept: (earningWithHoldingConcept: EarningWithholdingConceptDTO) => void
  paidTaxes: PaidTax[]; // Nueva propiedad
  addPaidTax: (taxtype: number, amount: Big, percentage: Big) => void; // Función para agregar
  removePaidTax: (taxtype: number) => void; // Función para eliminar
  supplier: any;
  totalWithoutTaxes:Big;
}

const TaxTypesComponent: React.FC<TaxTypesComponentProps> = (props: TaxTypesComponentProps) => {
    const [isLoading, setIsLoading] = useState(false)
    const [taxTypes, setTaxTypes] = useState<TaxTypeDTO[]>()
    
    useEffect(() => {
        const fetchTaxTypes = async () => {
          try {
            setIsLoading(true);
            const response = await axiosInstance.get('/api/secured/tax/getTaxTypeBySiteAndOperation', {
                params: { company:props.supplier.company, operation:props.operationType },
            });
            setTaxTypes(response.data.list);
          } catch (error) {
            console.error('Error fetching tax types:', error);
          } finally {
            setIsLoading(false);
          }
        };
    
        fetchTaxTypes();
      }, []);

    return (
        <div>
            <section className="emr-two-column-summary-grid">
                <p className="font-bold uppercase">TOTAL SIN RETENCIONES</p>
                <p className="font-bold uppercase">{formatCurrency(Number(props.totalWithoutTaxes.toFixed(2)), { currency: 'ARS' })}</p>
            </section>
            
            {taxTypes && taxTypes.length > 0 ? 
                <>
                    {taxTypes.map((tax, index) => (
                        <div className='mb-3'>
                          <TaxTypeItem tax={tax} totalToPay={props.totalToPay} setTotalToPay={props.setTotalToPay} earningWithHoldingConcept={props.earningWithHoldingConcept} setEarningWithHoldingConcept={props.setEarningWithHoldingConcept} paidTaxes={props.paidTaxes} addPaidTax={props.addPaidTax} totalWithoutTaxes={props.totalWithoutTaxes} supplier={props.supplier} removePaidTax={props.removePaidTax} />
                        </div>
                    ))}

                    <section className="emr-two-column-summary-grid mt-2">
                        <p className="font-bold uppercase title">Total a pagar</p>
                        <p className="font-bold uppercase title">{formatCurrency(Number(props.totalToPay.toFixed(2)), { currency: 'ARS' })}</p>
                    </section>
                </>
                :
                null
            }
        </div>
    )
}

export default TaxTypesComponent
